import React, { useState, useEffect } from 'react';
import axios from 'axios';
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import plLocale from '@fullcalendar/core/locales/pl';

function renderEventContent(eventInfo) {
    return(
        <div className={"calendarEvent"}>
            <a href={eventInfo.event.extendedProps.link} target='_blank' rel="noopener noreferrer">{eventInfo.event.title}</a>
        </div>
    )
}

export function Calendar() {
    const [events, setEvents] = useState([]);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/events`)
            .then(response => {
                const eventsWithClassName = response.data.map(event => ({
                    ...event,
                    className: "nc-event",
                    title: (event.location && event.location.trim()) ? `${event.name} - ${event.location}` : event.name
                }));
                setEvents(eventsWithClassName);
            })
            .catch(error => {
                console.error('Error fetching events:', error);
            });
    }, []);

    return <div id="calendar" className="calendar container-xxl py-5  section">
        <div className="container">
            <h2 className="text-secondary text-uppercase">Kalendarium</h2>
            <FullCalendar
                defaultView="dayGridMonth"
                header={{
                    left: "prev,next",
                    center: "title"
                }}
                locale={plLocale}
                themeSystem="Simplex"
                plugins={[dayGridPlugin]}
                eventContent={renderEventContent}
                events={events}
            />
        </div>
    </div>;
}